import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "main", "toggleButton"]
  static classes = ["open"]

  connect() {
    this._syncAria()
  }

  disconnect() {
    if (this.hasMainTarget && "inert" in HTMLElement.prototype) {
      this.mainTarget.inert = false
    }
    document.body.classList.remove("admin-body--nav-open")
    document.documentElement.classList.remove("admin-html--nav-open")
    this.element.classList.remove(this.openClass)
  }

  toggle() {
    this._setOpen(!this._isOpen())
  }

  close() {
    this._setOpen(false)
  }

  keydown(event) {
    if (event.key === "Escape" && this._isOpen()) {
      event.preventDefault()
      this.close()
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.focus()
      }
    }
  }

  closeOnNavLink(event) {
    const link = event.target.closest("a[href]")
    if (!link || !this.element.contains(link)) return
    this.close()
  }

  _isOpen() {
    return this.element.classList.contains(this.openClass)
  }

  _setOpen(open) {
    this.element.classList.toggle(this.openClass, open)
    document.body.classList.toggle("admin-body--nav-open", open)
    document.documentElement.classList.toggle("admin-html--nav-open", open)

    if (this.hasOverlayTarget) {
      this.overlayTarget.setAttribute("aria-hidden", open ? "false" : "true")
    }

    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute("aria-expanded", open ? "true" : "false")
      this.toggleButtonTarget.setAttribute(
        "aria-label",
        open ? "Закрыть меню навигации" : "Открыть меню навигации"
      )
    }

    if (this.hasMainTarget && "inert" in HTMLElement.prototype) {
      this.mainTarget.inert = open
    }
  }

  _syncAria() {
    const open = this._isOpen()
    if (this.hasOverlayTarget) {
      this.overlayTarget.setAttribute("aria-hidden", open ? "false" : "true")
    }
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
  }
}
